import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Music from "../pages/music/page";
import Store from "../pages/store/page";
import Gallery from "../pages/gallery/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/music", element: <Music /> },
  { path: "/store", element: <Store /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
